// OrderSummaryBadge.js
import React from "react";
// MATERIAL UI
import { StyledGreyBadgeNoBackgroundOnPrint } from "../styled/badge";
import { TypographyBoldOnPrint } from "../styled";

const ValueToLabelHorizontal = ({
  label,
  value,
  isbold,
  isLight = false,
  backgroundColor = "transparent",
  justifyContent = "start",
}) => {
  return (
    <StyledGreyBadgeNoBackgroundOnPrint
      display="flex"
      justifyContent={justifyContent}
      alignItems="center"
      backgroundcolor={backgroundColor}
    >
      <TypographyBoldOnPrint
        variant="body1"
        textAlign="center"
        fontWeight={isbold ? "bold" : isLight ? "light" : "normal"}
        printsize={10}
        sx={{ ml: 1 }}
      >
        {value}
      </TypographyBoldOnPrint>
      <TypographyBoldOnPrint
        variant="body1"
        textAlign="center"
        fontWeight={isbold ? "bold" : isLight ? "light" : "normal"}
        printsize={10}
        sx={{ ml: 1 }}
      >
        {label}
      </TypographyBoldOnPrint>
    </StyledGreyBadgeNoBackgroundOnPrint>
  );
};

export default ValueToLabelHorizontal;
